// TODO: add the Frame component to the image when it's available

import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-biography-view',
  styleUrl: 'biography.css',
  shadow: true,
})
export class Biography {
  @Prop() src: string;
  @Prop() alt: string;
  @Prop() nameandcredentials: string;
  @Prop() namecredentialslink: string;
  @Prop() titleaffiliation: string;
  @Prop() phonenumber: string;
  @Prop() email: string;

  render() {
    if (this.src && !this.alt) console.warn(`Biography image is missing alt text.`)
    const photoShow = this.src ? <div class="bio-image-container-view">{this.src && <img src={this.src} alt={this.alt} class="image-view" />}</div> : <div></div>; 
    const emailShow = this.email ? <p class="bio-email-view">Email: <a href={`mailto:${this.email}`}>{this.email}</a></p> : <div></div>;
    const phoneShow = this.phonenumber ? <p>Phone: <a href={`telephone:${this.phonenumber}`}>{this.phonenumber}</a></p> : <div></div>;
    return (
      <div class="container-view">
        {photoShow}
        <div class="bio-body-view">
          <h3 class="name-creds-view"><a href={this.namecredentialslink}>{this.nameandcredentials}</a></h3>
          <p>{this.titleaffiliation}</p>
          <div>
          <slot />
          </div>
          {emailShow}
          {phoneShow}
        </div>
      </div>
    );
  }
}
